export interface ManualPaymentDetails {
  paymentMethod: string;
  note?: string;
}

export function promptForManualPaymentDetails(
  onValidationError?: (message: string) => void,
): ManualPaymentDetails | null {
  const paymentMethodInput = window.prompt('Payment method (cash, check, ACH, wire, other):');
  if (paymentMethodInput === null) return null;

  const paymentMethod = paymentMethodInput.trim();
  if (!paymentMethod) {
    onValidationError?.('Payment method is required');
    return null;
  }

  const noteInput = window.prompt('Payment note (optional):');
  if (noteInput === null) return null;

  const note = noteInput.trim();
  return {
    paymentMethod,
    ...(note ? { note } : {}),
  };
}
